import { Epic, ofType } from 'redux-observable';
import { EpicDependencies } from '@ui/store/rootEpic';
import * as actions from '../actions';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { notification } from 'antd';

export const editCollection: Epic<any, any, any, EpicDependencies> = (
  action$,
  store,
  { collectionApi },
) =>
  action$.pipe(
    ofType(actions.EDIT_COLLECTION_ACTIONS.REQUESTED),
    switchMap(({ payload: { collection, file } }) =>
      collectionApi.editCollection(collection).pipe(
        switchMap(({ newCollection }) => {
          if (file) {
            return collectionApi
              .uploadPhoto(newCollection.id, file)
              .pipe(
                switchMap(newCollectionData =>
                  of(
                    actions.editCollectionSucceeded(newCollectionData),
                    actions.removeEditCollection(),
                  ),
                ),
              );
          }
          return of(actions.editCollectionSucceeded(newCollection));
        }),
        catchError(error =>
          of(actions.editCollectionFailed(error)).pipe(
            map(response => {
              notification.error({
                message: response.error.response.message,
              });
              return response;
            }),
          ),
        ),
      ),
    ),
  );



// WEBPACK FOOTER //
// ./src/scenes/Collections/services/epics/editCollection.ts